module.exports = __webpack_public_path__ + "img/157.5a4929d3.jpg";